<template>
  <el-select :value="valueMatch ? value : ''" v-bind="$attrs" v-on="$listeners">
    <el-option
      v-for="(item, index) in options"
      :key="index"
      :label="item[labelField || valueField]"
      :value="item[valueField]"
    />
  </el-select>
</template>

<script>
export default {
  name: 'CargoSelect',
  props: {
    value: { type: [String, Number], default: '' },
    options: { type: Array, required: true },
    labelField: { type: String, default: '' },
    valueField: { type: String, required: true }
  },
  computed: {
    valueMatch() {
      return this.options.findIndex(item => item[this.valueField] === this.value) > -1
    }
  }
}
</script>
